export default {
  awsIotHost: process.env.REACT_APP_AWS_IOT_URL,
  awsRegion: process.env.REACT_APP_AWS_REGION,
  awsCognitoUserPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POLL_ID,
  debug: false,
};
